let j2t = (j) => JSON.stringify(j)
export default {
  j2t,
}



// WEBPACK FOOTER //
// ./src/foundation/utils.js